import * as React from "react"
import {
  ListVaultFilesDocument,
  useDeleteDocumentMutation,
} from "@digits-graphql/frontend/graphql-bearer"
import { SvgCheckCircleSolid } from "@digits-shared/components/SVGIcons/solid/CheckCircleSolid.svg"
import stringHelper from "@digits-shared/helpers/stringHelper"
import useSession from "@digits-shared/hooks/useSession"
import { useChromeAlertContext } from "src/frontend/components/Shared/Alerts/ChromeAlertsContext"
import type FrontendSession from "src/frontend/session"

interface DeleteFile {
  fileId: string
  collectionId: string
}

export function useDeleteVaultFiles() {
  const { currentLegalEntityId: legalEntityId } = useSession<FrontendSession>()
  const { addAlert } = useChromeAlertContext()

  const [deleteFile, result] = useDeleteDocumentMutation({
    refetchQueries: [ListVaultFilesDocument],
    awaitRefetchQueries: true,
  })

  return {
    deleteFiles: React.useCallback(
      (df: DeleteFile[] | DeleteFile) => {
        const files = Array.isArray(df) ? df : [df]
        const promises = files.map((file) =>
          deleteFile({
            variables: {
              legalEntityId,
              documentId: file.fileId,
              documentCollectionId: file.collectionId,
            },
          })
        )
        return Promise.all(promises).then(() =>
          addAlert({
            id: "delete-file-success",
            message: `${files.length} ${stringHelper.pluralize(files.length, "document", "documents")} deleted`,
            SVGComponent: SvgCheckCircleSolid,
            autoDismiss: true,
          })
        )
      },
      [addAlert, deleteFile, legalEntityId]
    ),
    result,
  }
}
